import {useEffect, createContext, useReducer, Dispatch, ReactNode, useContext} from 'react';
import {CandidateContext} from './Candidate.context';

const initialState: AuthStateProps = {
	isAuthenticated: undefined,
	token: null,
	student: false
};

export interface AuthStateProps {
	student: boolean;
	isAuthenticated: boolean | undefined;
	token: null | string;
}

type Action = {type: 'LOGIN'; payload: {token: string; id: number; student: boolean}} | {type: 'LOGOUT'};

interface InitContextProps {
	state: AuthStateProps;
	dispatch: Dispatch<Action>;
}

export const AuthContext = createContext({} as InitContextProps);

const reducer = (state: AuthStateProps, action: Action) => {
	switch (action.type) {
		case 'LOGIN':
			localStorage.setItem('token', action.payload.token);
			localStorage.setItem('student', action.payload.student.toString());
			localStorage.setItem('id', action.payload.id.toString());
			return {
				...state,
				isAuthenticated: true,
				token: action.payload.token,
				id: action.payload.id,
				student: action.payload.student
			};
		case 'LOGOUT':
			localStorage.clear();
			return {
				...initialState,
				isAuthenticated: false
			};
		default:
			return state;
	}
};

const AuthProvider = ({children}: {children: ReactNode}) => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const value = {state, dispatch};

	useEffect(() => {
		const token = localStorage.getItem('token');
		const id = localStorage.getItem('id');
		const student = localStorage.getItem('student') === 'true';

		if (token && id) {
			dispatch({
				type: 'LOGIN',
				payload: {
					token,
					id: +id,
					student
				}
			});
		} else {
			dispatch({
				type: 'LOGOUT'
			});
		}
	}, []);
	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
